import { AccountTransfer } from "@/modules/transaction/components";
import type { IOperationPageProps } from "@/shared/common/types";

export const AccountTransferPage = ({ isEdit, isCopy }: IOperationPageProps) => (
  <AccountTransfer isCopy={isCopy} isEdit={isEdit}/>
);
